import http from '@/utils/request';

/**
 * 查询拓扑图信息
 * @param {string} params.createTimeTo 创建时间止，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.createTimeFrom 创建时间自，格式：yyyy-MM-dd HH:mm:ss
 * @param {string} params.serverName 服务名称，如果是查询服务端维度的数据，该字段必传
 * @param {string} params.source 来源，也代表具体某个应用，如果是查询客户端维度的相关数据，该字段必传
 * @param {string} params.env 应用环境
 */
export const queryTopologyInfo = (params) => http.get({
  url: '/topologyAnalyze/queryTopologyInfo',
  params,
});

/**
 * 查询服务信息
 */
export const queryServerInfo = (params) => http.get({
  url: '/topologyAnalyze/queryServerInfo',
  params,
});

/**
 * 查询用户行为
 * @param {string} params.analyzeTimeFrom 分析时间自
 * @param {string} params.analyzeTimeTo 分析时间止
 * @param {number} params.pageSize 分页大小
 * @param {number} params.pageNum 页码
 * @param {number} params.visitorId 访客id
 * @param {string} params.serverName 分页大小 服务名称，如果是查询服务端维度的数据，该字段必传
 * @returns
 */
export const queryUserBehavior = (params) => http.get({
  url: '/healthAnalyze/queryUserBehavior',
  params,
});

export const queryApiRequest = (params) => http.get({
  url: '/requestAnalyze/queryApiRequest',
  params,
});

// 查询用户列表
export const queryUserList = (data) => http.post({
  url: '/userAnalyze/queryUserList',
  data,
});

// 查询用户数量
export const queryUserCount = (data) => http.post({
  url: '/userAnalyze/queryUserCount',
  data,
});

// 查询活跃用户数量
export const queryActiveUserCount = (data) => http.post({
  url: '/userAnalyze/queryActiveUserCount',
  data,
});

// 查询操作系统分组
export const queryOsTop = (data) => http.post({
  url: '/deviceAnalyze/queryOsTop',
  data,
});

// 查询设备型号top
export const queryDeviceModelTop = (data) => http.post({
  url: '/deviceAnalyze/queryDeviceModelTop',
  data,
});

// 查询屏幕分辨率top
export const queryScreenResolutionTop = (data) => http.post({
  url: '/deviceAnalyze/queryScreenResolutionTop',
  data,
});

// 查询操作系统信息top
export const queryOsInfoTop = (data) => http.post({
  url: '/deviceAnalyze/queryOsInfoTop',
  data,
});

// 查询浏览器名称top
export const queryBrowserNameTop = (data) => http.post({
  url: '/deviceAnalyze/queryBrowserNameTop',
  data,
});

// 查询网络类型top
export const queryNetworkTypeTop = (data) => http.post({
  url: '/deviceAnalyze/queryNetworkTypeTop',
  data,
});

// 活跃用户列表
export const queryActiveUserList = (data) => http.post({
  url: '/userAnalyze/queryActiveUserList',
  data,
});

// 查询应用版本数量
export const queryVersionCount = (data) => http.post({
  url: '/versionAnalyze/queryVersionCount',
  data,
});

// 查询应用版本趋势
export const queryVersionTendency = (data) => http.post({
  url: '/versionAnalyze/queryVersionTendency',
  data,
});

// 查询应用版本列表
export const queryVersionList = (data) => http.post({
  url: '/versionAnalyze/queryVersionList',
  data,
});

// 应用版本分析 查询用户列表
export const queryVersionUserList = (data) => http.post({
  url: '/versionAnalyze/queryUserList',
  data,
});
